"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingInformationLogin = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Button_1 = require("../../../Button");
const Login_1 = require("../../../Form/Login");
const Popup_1 = require("../../../Popup");
require("./index.scss");
class BillingInformationLogin extends react_1.default.PureComponent {
    render() {
        const className = 'reservation-address';
        return (react_1.default.createElement("div", { className: `${className}__login-widget` },
            react_1.default.createElement("div", { className: `${className}__login-widget-text` },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/BillingInformation/Login/HaveAccount:question', defaultMessage: 'Do you already have an account?' })),
            react_1.default.createElement("div", { className: `${className}__login-widget-button` },
                react_1.default.createElement(Popup_1.Popup, { button: 'Login', ButtonComponent: (props) => (react_1.default.createElement(Button_1.Button, { onClick: (event) => {
                            const { onClick } = props;
                            onClick && onClick(event);
                            this.props.onClick(event);
                        }, text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/BillingInformation/Login/Button:Login', defaultMessage: 'Login' }), modificators: ['important', 'block'] })) },
                    react_1.default.createElement(Login_1.FormLogin, { onSubmit: this.props.onSubmit })))));
    }
}
exports.BillingInformationLogin = BillingInformationLogin;
BillingInformationLogin.defaultProps = {
    onClick: () => {
    },
    onSubmit: () => {
    },
};
//# sourceMappingURL=index.js.map